import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../features/auth/authSlice';

/**
 * Custom hook to access auth state and methods.
 * Provides a clean API for components to interact with auth.
 */
export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, token, status } = useSelector(state => state.auth);

  const isAuthenticated = Boolean(token && user);
  const isLoading = status === 'loading';

  const handleLogout = () => {
    dispatch(logout());
    // Redirect to login page after logout
    navigate('/login', { replace: true });
  };

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    logout: handleLogout,
    status
  };
};
